module.exports = __webpack_public_path__ + "static/img/5.55bb37d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/eng/5.png
// module id = NOMS
// module chunks = 0